import { Type } from 'class-transformer';
import { IsOptional, IsInt, Min } from 'class-validator';

export class SearchUserDto {
  @Type(() => Number)
  @IsInt()
  @Min(0)
  @IsOptional()
  page?: number;

  @Type(() => Number)
  @IsInt()
  @Min(0)
  @IsOptional()
  offset?: number;
}
